module.exports = __webpack_public_path__ + "static/map_usa_MW_hover-8ac2392ab47538c7ad2ac8233e333efb.png";